export default __webpack_public_path__ + "static/media/element_84.fe08b450.jpg";